import { render } from "./support.vue?vue&type=template&id=ded775be&scoped=true&ts=true"
import script from "./support.vue?vue&type=script&lang=ts"
export * from "./support.vue?vue&type=script&lang=ts"

import "./support.vue?vue&type=style&index=0&id=ded775be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded775be"]])

export default __exports__